<template>
  <span>
    <i @click="sortFun(1, item)" :style="{color : state !== undefined ? '' : '#67757c'}" :class="state === 1 ? '' : 'span_i_false'" class="zmdi top fs28 zmdi-caret-up"></i>
    <i @click="sortFun(0, item)" :style="{color : state !== undefined ? '' : '#67757c'}" :class="state === 0 ? '' : 'span_i_false'" class="zmdi bottom fs28 zmdi-caret-down"></i>
  </span>
</template>

<script>
  export default {
    data () {
      return {
        state: undefined
      }
    },
    props: {
      item: Object
    },
    components: {},
    computed: {},
    mounted () {},
    methods: {
      sortFun (i, data) {
        this.state = i
        this.$emit('sort-change', i, data)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .span_i_false{
    color: #ddd;
  }
</style>




// WEBPACK FOOTER //
// src/components-base/components-custom/table/caret.vue